import {
  ADD_GROUP,
  UPDATE_GROUP_INSTANCES,
  UPDATE_GROUP_INSTANCE_STATUSES,
  GET_GROUPS
} from './groupsActions';

const initialState = {
  groups: [],
  instances: {}
};

const simplifyStructure = ({ project_instance_data, ...rest }) => ({
  ...rest,
  ...project_instance_data
});

export const groupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GROUPS: {
      const { data } = action.payload.data;
      const parsedData = data.reduce(
        (acc, { instances, ...group }) => ({
          groups: [...acc.groups, group],
          instances: { ...acc.instances, [group.id]: instances }
        }),
        { groups: [], instances: {} }
      );
      return {
        ...state,
        ...parsedData
      };
    }
    case ADD_GROUP: {
      const newGroup = action.payload;
      return {
        ...state,
        groups: [...state.groups, newGroup],
        instances: { ...state.instances, [newGroup.id]: [] }
      };
    }
    // TODO: remove this and the next action as it is redundant
    case UPDATE_GROUP_INSTANCES: {
      const { instances, groupId } = action.payload;
      return {
        ...state,
        instances: {
          ...state.instances,
          [groupId]: instances.map(simplifyStructure)
        }
      };
    }
    case UPDATE_GROUP_INSTANCE_STATUSES: {
      const { statuses, groupId } = action.payload;
      const instances = state.instances[groupId];
      const withStatuses = instances.map((instance) => ({
        ...instance,
        ...statuses.find(({ flexbox_id }) => flexbox_id === instance.flexbox_id)
      }));
      return {
        ...state,
        instances: {
          ...state.instances,
          [groupId]: withStatuses
        }
      };
    }
    default:
      return state;
  }
};
